export const HUBSPOT_FORMS_TABLE = 'HUBSPOT_FORMS_TABLE';
export const ORGANIZATION_SETTINGS = 'ORGANIZATION_SETTINGS';